import { isNil } from 'ramda';

import { EOverlapType, EHeatingType, EGasSupplyType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { EHeatingType as DEPRECATED_EHeatingType } from '../../repositories/offer-card/entities/building/BuildingSchema';

/* istanbul ignore next */
export function getHouseMaterialType(materialType: string): string | null {
  switch (materialType) {
    case 'block':
      return 'Блочный';
    case 'boards':
      return 'Щитовой';
    case 'brick':
      return 'Кирпичный';
    case 'monolith':
      return 'Монолитный';
    case 'monolithBrick':
      return 'Монолитно кирпичный';
    case 'old':
      return 'Старый фонд';
    case 'panel':
      return 'Панельный';
    case 'stalin':
      return 'Сталинский';
    case 'wood':
      return 'Деревянный';
    case 'aerocreteBlock':
      return 'Газобетонный блок';
    case 'foamConcreteBlock':
      return 'Пенобетонный блок';
    case 'gasSilicateBlock':
      return 'Газосиликатный блок';
    case 'wireframe':
      return 'Каркасный';
  }

  return null;
}

/* istanbul ignore next */
export function getParkingType(parkingType: string): string | null {
  switch (parkingType) {
    case 'roof':
      return 'На крыше';
    case 'underground':
      return 'Подземная';
    case 'ground':
      return 'Наземная';
    case 'multilevel':
      return 'Многоуровневая';
    case 'open':
      return 'Открытая';
    case 'spontaneous':
      return 'Спонтанная';
  }

  return null;
}

const overlapTypeMap: { [key in EOverlapType]: string | null } = {
  [EOverlapType.Concrete]: 'Железобетонные',
  [EOverlapType.Mixed]: 'Смешанные',
  [EOverlapType.Other]: null, // Иные (не отображать)
  [EOverlapType.Unknown]: null, // Не известно (не отображать)
  [EOverlapType.Wood]: 'Деревянные',
};

export function getOverlapType(overlapType: EOverlapType): string | null {
  return overlapTypeMap[overlapType] || null;
}

const heatingTypeMap: { [key in EHeatingType]: string | null } = {
  [EHeatingType.Autonomous]: 'Автономное',
  [EHeatingType.AutonomousBoiler]: 'Автономная котельная',
  [EHeatingType.AutonomousGas]: 'Автономное газовое',
  [EHeatingType.Boiler]: 'Котел/Квартирное отопление',
  [EHeatingType.Central]: 'Центральное',
  [EHeatingType.Coal]: 'Центральное угольное',
  [EHeatingType.Diesel]: 'Дизельное',
  [EHeatingType.Electric]: 'Электрическое',
  [EHeatingType.Fireplace]: 'Камин',
  [EHeatingType.Gas]: 'Центральное газовое',
  [EHeatingType.GasWaterHeater]: 'Индивидуальный тепловой пункт',
  [EHeatingType.Has]: 'Есть',
  [EHeatingType.ITP]: 'Индивидуальный тепловой пункт',
  [EHeatingType.None]: null, // Не указано (не отображать)
  [EHeatingType.Other]: null, // Другое (не отображать)
  [EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
  [EHeatingType.Stove]: 'Печь',
  [EHeatingType.Without]: 'Нет',
};

const heatingTypeMapV2: { [key in DEPRECATED_EHeatingType]: string | null } = {
  [DEPRECATED_EHeatingType.Autonomous]: 'Автономное',
  [DEPRECATED_EHeatingType.AutonomousGas]: 'Автономное газовое',
  [DEPRECATED_EHeatingType.Boiler]: 'Котел/Квартирное отопление',
  [DEPRECATED_EHeatingType.Central]: 'Центральное',
  [DEPRECATED_EHeatingType.CentralCoal]: 'Центральное угольное',
  [DEPRECATED_EHeatingType.CentralGas]: 'Центральное газовое',
  [DEPRECATED_EHeatingType.Diesel]: 'Дизельное',
  [DEPRECATED_EHeatingType.Electric]: 'Электрическое',
  [DEPRECATED_EHeatingType.Fireplace]: 'Камин',
  [DEPRECATED_EHeatingType.No]: 'Нет',
  [DEPRECATED_EHeatingType.Other]: null, // Другое (не отображать)
  [DEPRECATED_EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
  [DEPRECATED_EHeatingType.Stove]: 'Печь',
};

export function getHeatingType(heatingType: EHeatingType): string | null {
  return heatingTypeMap[heatingType] || null;
}

export function getHeatingTypeV2(heatingType: DEPRECATED_EHeatingType): string | null {
  return heatingTypeMapV2[heatingType] || null;
}

const gasSupplyTypeMap: { [key in EGasSupplyType]: string | null } = {
  [EGasSupplyType.Autonomous]: 'Автономное',
  [EGasSupplyType.Central]: 'Центральное',
  [EGasSupplyType.Unknown]: null, // Не известно (не отображать)
  [EGasSupplyType.Without]: null, // Отсутствует (не отображать)
};

export function getGasSupplyType(gasSupplyType: EGasSupplyType): string | null {
  return gasSupplyTypeMap[gasSupplyType] || null;
}

export function getHasLabel(value: boolean | null) {
  if (isNil(value)) {
    return null;
  }

  return value ? 'Есть' : 'Нет';
}
